<template>
    <b-nav tabs class="ml-1">
        <b-nav-item :to="'/submitter/'+applicationId" :active="'submitter' === this.$route.name">Submitter</b-nav-item>
        <b-nav-item :to="'/contacts/'+applicationId" :active="'contacts' === this.$route.name">Contacts</b-nav-item>
        <b-nav-item :to="'/attachments/'+applicationId" :active="'attachments' === this.$route.name">Documents</b-nav-item>
    </b-nav>
</template>


<script>
export default {
    props: {
        applicationId: [String],
    },
}
</script>
<style>
    .nav-link, .nav-link:hover {
        color: #495057
    }
</style>